// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XtSwlFD5yioxKUQBthyt{align-items:center;display:flex}.iWPO0vSaICwnvIlibqSQ .mCwsIYXMcyfQze3Xbbnc{margin-left:6px}.mCwsIYXMcyfQze3Xbbnc{color:var(--content-primary-primary);max-width:150px}._12ANbtDgaQgAUkMRvSy{color:var(--content-neutral-primary);margin-left:8px}.ze5b3gbM90YpP2_yEv3H{height:auto;min-height:32px}.Anj7PJQYkrkCDnDl8lsR{background:var(--background-brand-subtle-primary);color:var(--content-primary-tertiary)}.ZvwBB6F9u0U4YdCH0_X0{color:var(--content-primary-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `XtSwlFD5yioxKUQBthyt`,
	"wrap--checkbox": `iWPO0vSaICwnvIlibqSQ`,
	"wrapCheckbox": `iWPO0vSaICwnvIlibqSQ`,
	"title": `mCwsIYXMcyfQze3Xbbnc`,
	"count": `_12ANbtDgaQgAUkMRvSy`,
	"dropdown": `ze5b3gbM90YpP2_yEv3H`,
	"highlighter": `Anj7PJQYkrkCDnDl8lsR`,
	"highlighter--label": `ZvwBB6F9u0U4YdCH0_X0`,
	"highlighterLabel": `ZvwBB6F9u0U4YdCH0_X0`
};
export default ___CSS_LOADER_EXPORT___;
